import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const ChartComponent = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null); // to track Chart.js instance

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d');

    // ✅ Destroy old chart if it exists
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    // ✅ Create new chart with updated data
    chartInstanceRef.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: [{
          label: 'Lead Data',
          data: data.values,
          backgroundColor: [
            "#B19CD9",
            "#4BC0C0",
            "#FF6384",
            "#FF9933",
            "#33FF99",
            "#FF6666",
            "#66CCFF",
            "#999966",
          ],
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 0.5,
        }],
      },
      options: {
        responsive: true,
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    });

    // Cleanup function still needed on unmount
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [data]); // ✅ Will rerun when `data` changes

  return <canvas ref={chartRef} />;
};

export default ChartComponent;
